class GridLayoutSelector extends window.HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".grid-layout-btn");
    this.productsGrid = document.querySelector(".products-list");
    if (!this.productsGrid) return;
    this.loadSavedLayout();
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.handleLayoutChange.bind(this));
    });
  }
  loadSavedLayout() {
    const savedColumns = localStorage.getItem("grid-columns");
    if (savedColumns) {
      this.updateGridLayout(savedColumns);
      this.updateActiveButton(savedColumns);
    }
  }
  handleLayoutChange(evt) {
    const button = evt.currentTarget;
    const columns = button.dataset.gridColumns;
    if (!columns) return;
    this.updateGridLayout(columns);
    this.updateActiveButton(columns);
    localStorage.setItem("grid-columns", columns);
  }
  updateGridLayout(columns) {
    if (!this.productsGrid) return;
    this.productsGrid.classList.remove(
      "grid-cols-2",
      "grid-cols-3",
      "grid-cols-4",
      "lg:grid-cols-2",
      "lg:grid-cols-3",
      "lg:grid-cols-4",
      "xl:grid-cols-2",
      "xl:grid-cols-3",
      "xl:grid-cols-4"
    );
    switch (columns) {
      case "2":
        this.productsGrid.classList.add("grid-cols-2");
        break;
      case "3":
        this.productsGrid.classList.add("grid-cols-2", "lg:grid-cols-3");
        break;
      case "4":
        this.productsGrid.classList.add(
          "grid-cols-2",
          "lg:grid-cols-3",
          "xl:grid-cols-4"
        );
        break;
    }
  }
  updateActiveButton(columns) {
    this.buttons.forEach((button) => {
      button.classList.remove(
        "active",
        "border-primary",
        "bg-primary",
        "text-white"
      );
      button.classList.add("border-gray-300");
    });
    const activeButton = this.querySelector(`[data-grid-columns="${columns}"]`);
    if (activeButton) {
      activeButton.classList.add(
        "active",
        "border-gray-300",
        "bg-primary",
        "text-white"
      );
      activeButton.classList.remove("border-gray-300");
    }
  }
}
window.customElements.define("grid-layout-selector", GridLayoutSelector);
export {
  GridLayoutSelector as default
};
